import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as homeActions from '../../../home/redux/actions';
import * as myAccountActions from '../../../my-account/redux/actions';
import * as serviceActions from '../../../pb-service-list/redux/actions';

import React, { useState } from 'react';

import CancelTicketInput from '../../ThemeTen/components/cancel-input';
import CuponeraInput from '../../ThemeTen/components/copunera-inputs';
import SearchInput from '../../ThemeTen/components/search-input';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import { withTranslation } from 'react-i18next';

const getTabs = operator => {
	const defaultTabs = [
		{
			active: true,
			id: '434',
			label: operator && operator.operator_name === 'buseslafit' || operator && operator.operator_name === 'santarosa' || operator && operator.operator_name === 'losnavegadores' ? 'Comprar pasaje' : 'COMPRAR PASAJE',
			activeIcon: 'BA',
			InActiveIcon: 'BIA',
			component: props => <SearchInput data={props} />,
		},

		{
			active: false,
			id: '32',
			label: operator && operator.operator_name === 'buseslafit' || operator.operator_name === 'santarosa' || operator && operator.operator_name === 'losnavegadores' ? 'Anular pasaje' : 'ANULAR PASAJE',
			activeIcon: 'CA',
			InActiveIcon: 'CIA',
			component: props => <CancelTicketInput data={props} />,
		},
	];

	if (operator && operator.is_change_ticket) {
		defaultTabs.push({
			active: false,
			id: '3r4',
			label: operator && operator.operator_name === 'buseslafit' || operator.operator_name === 'santarosa' || operator && operator.operator_name === 'losnavegadores' ? 'Cambiar pasaje' : 'CAMBIAR PASAJE',
			activeIcon: 'CTA',
			InActiveIcon: 'CTIA',
			is_change_ticket: true,
			component: (props, changeTicket) => (
				<CancelTicketInput data={props} changeTicket={changeTicket} />
			),
		});
	}
	if (operator && operator.is_couponera_enabled) {
		defaultTabs.push(
			{
				active: false,
				id: '3',
				label: operator && operator.operator_name === 'buseslafit' || operator.operator_name === 'santarosa' || operator && operator.operator_name === 'losnavegadores' ? 'Confirmar Pasaje' : 'CONFIRMAR PASAJE',
				activeIcon: 'CCA',
				InActiveIcon: 'CCIA',
				component: props => <SearchInput data={props} is_mot />,
			},

			{
				active: false,
				id: '4',
				label: operator && operator.operator_name === 'buseslafit' || operator.operator_name === 'santarosa' || operator && operator.operator_name === 'losnavegadores' ? 'Cuponera' : 'CUPONERA',
				activeIcon: 'CUA',
				InActiveIcon: 'CUIA',
				component: props => <CuponeraInput data={props} />,
			},
		);
	}

	return defaultTabs;
};

const ThemeTenSearchBox = props => {
	const { operator } = props;
	const tabs = getTabs(operator);
	const [selectedTab, setSelectedTab] = useState(tabs[0]);
	const [changeTicket, setChangeTicket] = useState(false);

	const handleChangeTab = item => {
		setSelectedTab(item);
		setChangeTicket(item.is_change_ticket ? true : false);
		localStorage.setItem('isChangeTicket', item.is_change_ticket ? true : false);
	};

	const getStyle = selected => {

		if (operator.operator_name === 'erbuc') {
			return {
				background: selected
					? '#fff'
					: '#59977f',
				color: selected ? '#464647' : '#fff',
			};
		}
		if (operator.operator_name === 'traveltur') {
			return {
				background: selected
					? '#2767e6'
					: '#fa6400',
				color: 'white',
			};
		}
		if (operator.operator_name === 'lineaazul') {
			return {
				color: selected ? '#f8ae26' : '#fff',
			};
		}
		if (operator.operator_name === 'tacoha') {
			return {
				background: selected ? 'rgb(12, 44, 154)' : 'rgb(103, 122, 188)',
				color: 'white',
			};
		}
		if (operator.operator_name === 'sanantonio') {
			return {
				background: selected ? 'rgb(230, 98, 17)' : 'rgb(238, 147, 2)',
				color: 'white',
			};
		}
		if (operator.operator_name === 'liquine') {
			return {
				background: selected ? 'rgb(128, 214, 51)' : 'rgb(77, 173, 39)',
				color: 'white',
			};
		}
		if (operator.operator_name === 'aeroquinta') {
			return {
				background: selected ? '#1A203A' : '#4079BC',
				color: 'white',
			};
		}
		if (operator.operator_name === 'busnorte') {
			return {
				background: selected ? '#fff' : '#166737',
				color: selected ? '#00602e' : '#fff',
			};
		}
		if (operator.operator_name === 'expressonorte') {
			return {
				background: selected ? '#fff' : '#009f0c',
				color: selected ? '#464647' : '#fff',
			};
		}
		if (operator.operator_name === 'chilebus') {
			return {
				background: selected ? '#fff' : 'rgb(10, 70, 158)',
				color: selected ? '#464647' : '#fff',
			};
		}

		if (operator.operator_name === 'trrass') {
			return {
				background: selected ? '#fff' : '#1d3b7d',
				color: selected ? '#464647' : '#fff',
			};
		}
		if (operator.operator_name === 'bahiaazul') {
			return {
				background: selected ? '#fff' : '#005299',
				color: selected ? '#464647' : '#fff',
			};
		}
		if (operator.operator_name === 'tepual') {
			return {
				background: selected ? '#fff' : '#005924',
				color: selected ? '#464647' : '#fff',
			};
		}
		if (operator.operator_name === 'jeldres') {
			return {
				background: selected ? '#fff' : '#166737',
				color: selected ? '#166737' : '#fff',
			};
		}
		if (operator.operator_name === 'ivergrama') {
			return {
				background: selected ? '#cf112b' : '#84031f',
				color: '#fff',
			};

		}
		if (operator.operator_name === 'arzola') {
			return {
				background: selected ? '#93e61a' : '#737578',
				color: '#fff',
			};

		}
		if (operator.operator_name === 'buseslafit') {
			return {
				background: selected ? "#fff" : "#0088cc",
				color: selected ? "#0088cc" : "#fff",
			};

		}
		if (operator.operator_name === 'santarosa') {
			const activerosa = `${selected ? 'selected tab-selected' : ''}`;

			return {
				background: selected ? '#ffffff' : '#b52c1f',
				color: selected ? '#b52c1f' : '#ffffff',
				activerosa,
			};
		}

		if (operator && operator.theme_type === 3 || operator && operator.theme_type === 10 || operator && operator.theme_type === 5 || operator && operator.theme_type === 4) {
			return {
				background: selected
					? operator.color_codes.search_active_tab
					: operator.color_codes.search_inactive_tab,
				color: 'white',
			};
		}


	};

	const tabItem = item => {
		const selected = selectedTab.id === item.id;
		return (

			operator && operator.operator_name === 'lineaazul' ?


				(<div
					className={`${tabs.length > 3 && 'flex1'} tab d-flex-c bold-text ${selected ? 'new-class' : ''}`}
					onClick={() => handleChangeTab(item)}
					style={getStyle(selected)}
					key={item.key}
				>
					<img
						src={getIcons(selected ? item.activeIcon : item.InActiveIcon, operator)}
						alt={item.label}
						className={`bookticketicon ${selected ? 'selectedone' : ''}`}
					/>
					{item.label}
				</div>) : (<div
					className={`${tabs.length > 3 && 'flex1'} tab d-flex-c bold-text ${selected ? 'new-class' : ''}`}
					onClick={() => handleChangeTab(item)}
					style={getStyle(selected)}
					key={item.key}
				>
					<img
						src={getIcons(selected ? item.activeIcon : item.InActiveIcon, operator)}
						alt={item.label}
						className={`bookticketicon ${selected ? 'selectedone' : ''}`}
					/>
					{item.label}
				</div>)


		);
	};

	return (

		operator && operator.theme_type === 3 || operator && operator.theme_type === 10 || operator && operator.theme_type === 5 || operator && operator.theme_type === 4 || operator && operator.operator_name === 'santarosa' || operator && operator.operator_name === 'buseslafit' ?
			(
				// <div className="themes-theme-ten-search-box new-margin santa-searchbox">
				// 	<div className="new-container">
				// 		<div className="home-main-selection-container">
				// 			<div className="tabs f-14">
				// 				{tabs.map(val => {
				// 					return tabItem(val);
				// 				})}
				// 			</div>
				// 			<div
				// 				className="kupos-card kupos-card-padding-l"
				// 				style={{ borderTopRightRadius: 0, borderTopLeftRadius: 0 }}
				// 			>
				// 				{selectedTab.component(props, changeTicket)}
				// 			</div>
				// 		</div>
				// 	</div>
				// </div>
				<div
					className={`themes-theme-ten-search-box new-margin newsearchbox ${operator && operator.operator_name === "santarosa" || operator && operator.operator_name === "buseslafit" ? "themes-theme-ten-search-box new-margin santa-searchbox" : operator && operator.operator_name === "losnavegadores" ? "mt-3" : operator && operator.operator_name === "basetorres" ? " searchbox-small buttontrans" : " searchbox-small"
						}`}
				>
					<div className="new-container">
						<div className="home-main-selection-container">
							<div className="tabs f-14" style={{
								backgroundColor: operator && operator.operator_name === "santarosa" || operator && operator.operator_name === "buseslafit" ? operator && operator.color_codes.secondary_color : null,
							}}>
								{tabs.map(val => {
									return tabItem(val);
								})}
							</div>
							<div
								className="kupos-card kupos-card-padding-l"
								style={{ borderTopRightRadius: 0, borderTopLeftRadius: 0 }}
							>
								{selectedTab.component(props, changeTicket)}
							</div>
						</div>
					</div>
				</div >
			) : (

				<div className="themes-theme-two-search-box no-margin-top common-design-form">

					<div className="new-container">
						<div className="home-main-selection-container">
							<div className="kupos-card  kupos-card-padding-l"

								style={{
									background: operator && operator.color_codes && operator.color_codes.tertiary_color ? operator.color_codes.tertiary_color : '',
								}}
							>
								<div className="tabs f-13 extra-margin-left">
									{tabs.map(val => {
										return tabItem(val);
									})}
								</div>
								<div
									className="tab-1  pointer"
									style={{ borderTopRightRadius: 0, borderTopLeftRadius: 0 }}
								>
									{selectedTab.component(props, changeTicket)}
								</div>
							</div>
						</div>
					</div>
				</div>
			)
	)
		;
};



/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
		home: state.home,
		common: state.common,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(
			{
				...actions,
				...serviceActions,
				...myAccountActions,
				...commonActions,
				...homeActions,
			},
			dispatch,
		),
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withTranslation('common')(ThemeTenSearchBox));



// WEBPACK FOOTER //
// ./src/features/themes/common/search-box/CommonSearchBox.js